var __create = Object.create;
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __markAsModule = (target) => __defProp(target, "__esModule", { value: true });
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __reExport = (target, module2, copyDefault, desc) => {
  if (module2 && typeof module2 === "object" || typeof module2 === "function") {
    for (let key of __getOwnPropNames(module2))
      if (!__hasOwnProp.call(target, key) && (copyDefault || key !== "default"))
        __defProp(target, key, { get: () => module2[key], enumerable: !(desc = __getOwnPropDesc(module2, key)) || desc.enumerable });
  }
  return target;
};
var __toESM = (module2, isNodeMode) => {
  return __reExport(__markAsModule(__defProp(module2 != null ? __create(__getProtoOf(module2)) : {}, "default", !isNodeMode && module2 && module2.__esModule ? { get: () => module2.default, enumerable: true } : { value: module2, enumerable: true })), module2);
};
var __toCommonJS = /* @__PURE__ */ ((cache) => {
  return (module2, temp) => {
    return cache && cache.get(module2) || (temp = __reExport(__markAsModule({}), module2, 1), cache && cache.set(module2, temp), temp);
  };
})(typeof WeakMap !== "undefined" ? /* @__PURE__ */ new WeakMap() : 0);

// index.ts
var tau_react_exports = {};
__export(tau_react_exports, {
  TauAccordion: () => TauAccordion,
  TauAccordionBar: () => TauAccordionBar,
  TauAccordionContent: () => TauAccordionContent,
  TauButton: () => TauButton,
  TauCheckbox: () => TauCheckbox,
  TauDrawer: () => TauDrawer,
  TauFlex: () => TauFlex,
  TauIcon: () => TauIcon,
  TauOption: () => TauOption,
  TauPage: () => TauPage,
  TauRipple: () => TauRipple,
  TauSelect: () => TauSelect,
  TauSwitch: () => TauSwitch,
  TauTheme: () => TauTheme
});
var import_loader2 = require("tauix/stencil/loader");

// forerunner/react-component-lib/createComponent.tsx
var import_react2 = __toESM(require("react"));

// forerunner/react-component-lib/utils/index.tsx
var import_react = __toESM(require("react"));

// forerunner/react-component-lib/utils/case.ts
var dashToPascalCase = (str) => str.toLowerCase().split("-").map((segment) => segment.charAt(0).toUpperCase() + segment.slice(1)).join("");
var camelToDashCase = (str) => str.replace(/([A-Z])/g, (m) => `-${m[0].toLowerCase()}`);

// forerunner/react-component-lib/utils/attachProps.ts
var attachProps = (node, newProps, oldProps = {}) => {
  if (node instanceof Element) {
    const className = getClassName(node.classList, newProps, oldProps);
    if (className !== "") {
      node.className = className;
    }
    Object.keys(newProps).forEach((name) => {
      if (name === "children" || name === "style" || name === "ref" || name === "class" || name === "className" || name === "forwardedRef") {
        return;
      }
      if (name.indexOf("on") === 0 && name[2] === name[2].toUpperCase()) {
        const eventName = name.substring(2);
        const eventNameLc = eventName[0].toLowerCase() + eventName.substring(1);
        if (!isCoveredByReact(eventNameLc)) {
          syncEvent(node, eventNameLc, newProps[name]);
        }
      } else {
        node[name] = newProps[name];
        const propType = typeof newProps[name];
        if (propType === "string") {
          node.setAttribute(camelToDashCase(name), newProps[name]);
        }
      }
    });
  }
};
var getClassName = (classList, newProps, oldProps) => {
  const newClassProp = newProps.className || newProps.class;
  const oldClassProp = oldProps.className || oldProps.class;
  const currentClasses = arrayToMap(classList);
  const incomingPropClasses = arrayToMap(newClassProp ? newClassProp.split(" ") : []);
  const oldPropClasses = arrayToMap(oldClassProp ? oldClassProp.split(" ") : []);
  const finalClassNames = [];
  currentClasses.forEach((currentClass) => {
    if (incomingPropClasses.has(currentClass)) {
      finalClassNames.push(currentClass);
      incomingPropClasses.delete(currentClass);
    } else if (!oldPropClasses.has(currentClass)) {
      finalClassNames.push(currentClass);
    }
  });
  incomingPropClasses.forEach((s) => finalClassNames.push(s));
  return finalClassNames.join(" ");
};
var isCoveredByReact = (eventNameSuffix) => {
  if (typeof document === "undefined") {
    return true;
  } else {
    const eventName = "on" + eventNameSuffix;
    let isSupported = eventName in document;
    if (!isSupported) {
      const element = document.createElement("div");
      element.setAttribute(eventName, "return;");
      isSupported = typeof element[eventName] === "function";
    }
    return isSupported;
  }
};
var syncEvent = (node, eventName, newEventHandler) => {
  const eventStore = node.__events || (node.__events = {});
  const oldEventHandler = eventStore[eventName];
  if (oldEventHandler) {
    node.removeEventListener(eventName, oldEventHandler);
  }
  node.addEventListener(eventName, eventStore[eventName] = function handler(e) {
    if (newEventHandler) {
      newEventHandler.call(this, e);
    }
  });
};
var arrayToMap = (arr) => {
  const map = /* @__PURE__ */ new Map();
  arr.forEach((s) => map.set(s, s));
  return map;
};

// forerunner/react-component-lib/utils/index.tsx
var setRef = (ref, value) => {
  if (typeof ref === "function") {
    ref(value);
  } else if (ref != null) {
    ref.current = value;
  }
};
var mergeRefs = (...refs) => {
  return (value) => {
    refs.forEach((ref) => {
      setRef(ref, value);
    });
  };
};
var createForwardRef = (ReactComponent, displayName) => {
  const forwardRef = (props, ref) => {
    return /* @__PURE__ */ import_react.default.createElement(ReactComponent, __spreadProps(__spreadValues({}, props), {
      forwardedRef: ref
    }));
  };
  forwardRef.displayName = displayName;
  return import_react.default.forwardRef(forwardRef);
};

// forerunner/react-component-lib/createComponent.tsx
var createReactComponent = (tagName, ReactComponentContext, manipulatePropsFunction, defineCustomElement2) => {
  if (defineCustomElement2 !== void 0) {
    defineCustomElement2();
  }
  const displayName = dashToPascalCase(tagName);
  const ReactComponent = class extends import_react2.default.Component {
    constructor(props) {
      super(props);
      this.setComponentElRef = (element) => {
        this.componentEl = element;
      };
    }
    componentDidMount() {
      this.componentDidUpdate(this.props);
    }
    componentDidUpdate(prevProps) {
      attachProps(this.componentEl, this.props, prevProps);
    }
    render() {
      const _a = this.props, { children, forwardedRef, style, className, ref } = _a, cProps = __objRest(_a, ["children", "forwardedRef", "style", "className", "ref"]);
      let propsToPass = Object.keys(cProps).reduce((acc, name) => {
        if (name.indexOf("on") === 0 && name[2] === name[2].toUpperCase()) {
          const eventName = name.substring(2).toLowerCase();
          if (typeof document !== "undefined" && isCoveredByReact(eventName)) {
            acc[name] = cProps[name];
          }
        } else {
          acc[name] = cProps[name];
        }
        return acc;
      }, {});
      if (manipulatePropsFunction) {
        propsToPass = manipulatePropsFunction(this.props, propsToPass);
      }
      const newProps = __spreadProps(__spreadValues({}, propsToPass), {
        ref: mergeRefs(forwardedRef, this.setComponentElRef),
        style
      });
      return (0, import_react2.createElement)(tagName, newProps, children);
    }
    static get displayName() {
      return displayName;
    }
  };
  if (ReactComponentContext) {
    ReactComponent.contextType = ReactComponentContext;
  }
  return createForwardRef(ReactComponent, displayName);
};

// forerunner/react-component-lib/createOverlayComponent.tsx
var import_react3 = __toESM(require("react"));
var import_react_dom = __toESM(require("react-dom"));

// forerunner/components.ts
var import_loader = require("tauix/stencil/loader");
(0, import_loader.applyPolyfills)().then(() => (0, import_loader.defineCustomElements)());
var TauAccordion = /* @__PURE__ */ createReactComponent("tau-accordion");
var TauAccordionBar = /* @__PURE__ */ createReactComponent("tau-accordion-bar");
var TauAccordionContent = /* @__PURE__ */ createReactComponent("tau-accordion-content");
var TauButton = /* @__PURE__ */ createReactComponent("tau-button");
var TauCheckbox = /* @__PURE__ */ createReactComponent("tau-checkbox");
var TauDrawer = /* @__PURE__ */ createReactComponent("tau-drawer");
var TauFlex = /* @__PURE__ */ createReactComponent("tau-flex");
var TauIcon = /* @__PURE__ */ createReactComponent("tau-icon");
var TauOption = /* @__PURE__ */ createReactComponent("tau-option");
var TauPage = /* @__PURE__ */ createReactComponent("tau-page");
var TauRipple = /* @__PURE__ */ createReactComponent("tau-ripple");
var TauSelect = /* @__PURE__ */ createReactComponent("tau-select");
var TauSwitch = /* @__PURE__ */ createReactComponent("tau-switch");
var TauTheme = /* @__PURE__ */ createReactComponent("tau-theme");

// index.ts
(0, import_loader2.applyPolyfills)().then(() => {
  (0, import_loader2.defineCustomElements)(window);
});
module.exports = __toCommonJS(tau_react_exports);
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  TauAccordion,
  TauAccordionBar,
  TauAccordionContent,
  TauButton,
  TauCheckbox,
  TauDrawer,
  TauFlex,
  TauIcon,
  TauOption,
  TauPage,
  TauRipple,
  TauSelect,
  TauSwitch,
  TauTheme
});
/**
 * Checks if an event is supported in the current execution environment.
 * @license Modernizr 3.0.0pre (Custom Build) | MIT
 */
